import { useEffect, useRef, useState } from "react";

export function usePoll(fn, active, interval = 2500) {
  const saved = useRef(fn);
  saved.current = fn;
  useEffect(() => {
    if (!active) return undefined;
    const t = setInterval(() => saved.current(), interval);
    return () => clearInterval(t);
  }, [active, interval]);
}

export function useElapsed(startIso, running) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [running]);
  if (!startIso) return 0;
  return Math.max(0, Math.floor((now - new Date(startIso).getTime()) / 1000));
}

export const fmtElapsed = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
